<template>
    <webinar-template
        :config="config"
    />
</template>

<script>
import WebinarTemplate from './WebinarTemplate';

export default {
    components: {
        WebinarTemplate,
    },

    data: () => ({
        config: {
            title: 'Upcoming Training Webinar',
            date: 'September 23th 3PM Eastern (12PM Pacific)',
            duration: '45 mins',
            subtitle: 'Part 1: Getting Started with Fusebox',
            avatar: {
                src: '/images/help-avatar.jpg',
                alt: 'Nōn Wels',
            },
            hosts: '<strong>Nōn Wels</strong> and <strong>Jonathan Hess</strong>',
            description: 'Join the first in a 2-part webinar series, Getting Started with Fusebox on September 23 at 12pm PST / 3pm EST! Non and Jonathan will walk you through set up, downloading your plugins, and getting Fusebox on your WordPress site. Plus, time for feedback and a Q&A!',
            cta: {
                url: 'https://my.demio.com/ref/P4picZK9HFnp6Zmw',
                text: 'Register Now',
            },
        },
    }),
};
</script>
